module.exports = __webpack_public_path__ + "img/kommune-1841.adf32e42.svg";